import { render, staticRenderFns } from "./ModalBanner.vue?vue&type=template&id=80dbbb12&scoped=true"
import script from "./ModalBanner.vue?vue&type=script&lang=js"
export * from "./ModalBanner.vue?vue&type=script&lang=js"
import style0 from "./ModalBanner.vue?vue&type=style&index=0&id=80dbbb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dbbb12",
  null
  
)

export default component.exports